import { ControlType, FetchStatus, Property } from "../../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../../widgets";
import { FC, useCallback } from "react";
import { RadioGroupProperties, useRadioGroupProperties } from "./RadioGroupProperties";

import { DraftRadioGroupComponent } from "./DraftRadioGroupComponent";
import { IControlAttributes } from "../../../../../base/models";
import { InputLabel } from "../../InputLabel";
import { RadioGroupField } from "./RadioGroupField";
import { Registry } from "../../../../../base/register";
import { SimpleRadioGroup } from "./SimpleRadioGroup";

export const RadioGroupComponent: FC<IControlAttributes> = ({
    control, className, props
}) => {
    const { status, properties, bindings, error } = useRadioGroupProperties(props);
    const { label, required, title } = properties || {}
    const containerClass = label ? className : ''
    const inputClass = label ? '' : className

    const getRadioGroupNode = useCallback(() => {
        const binding = bindings?.getBinding(Property.InitValue);
        switch (binding?.type) {
            case "Field":
                return <RadioGroupField
                    id={control.controlId}
                    title={title}
                    name={binding.boundValue}
                    {...properties}
                    className={inputClass}
                />
            case "Const":
            case "Expression":
            default:
                return <SimpleRadioGroup
                    id={control.controlId}
                    title={title}
                    {...properties}
                    value={binding?.value}
                    className={inputClass}
                />
        }

        // eslint-disable-next-line
    }, [properties, bindings, control])

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <InputLabel
        htmlFor={control.controlId}
        title={title}
        label={label}
        required={required}
        className={containerClass}>
        {getRadioGroupNode()}
    </InputLabel>
}

Registry.addControl({
    id: "b51a68c0-ede3-4fa0-855b-58f812808874",
    name: "Radio Group",
    type: ControlType.Radio,
    properties: RadioGroupProperties,
    component: RadioGroupComponent,
    draftComponent: DraftRadioGroupComponent
})
